import store from "../../../../../app/store";

const deleteBot = async (botId) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/bot/${botId}`;

  const token = store.getState().auth.token;

  if (!token) {
    return {
      data: null,
      error: true,
      msg: "Authentication failed. Please log in again.",
    };
  }

  const option = {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await fetch(url, option);

    if (!res.ok) {
      const errMsg =
        res.status === 404
          ? "Bot not found."
          : res.status === 403
          ? "Unauthorized action."
          : "Failed to delete bot. Please try again.";

      return {
        data: null,
        error: true,
        msg: errMsg,
      };
    }

    const data = await res.json();
    return {
      data,
      error: false,
      msg: "Bot deleted successfully.",
    };
  } catch (err) {
    return {
      data: null,
      error: true,
      msg: "Server error. Please check your connection and try again.",
    };
  }
};

export default deleteBot;
